import { SearchspringFetcher, SearchspringProduct, SearchspringSearchResponse } from "@app/lib/searchspring";
import { useSearchspring } from "@app/providers/searchspring";
import { useEffect, useMemo, useState } from "react";

export function useSearchspringProductSearch(initialResult?: any) {
  const [currentResult, setCurrentResult] = useState(initialResult);

  const { refine, response } = useSearchspring<SearchspringProduct, SearchspringSearchResponse>({
    client: new SearchspringProduct("products"),
    isInitiallyRun: false,
    shouldSkipEmptyOptions: true,
  });

  useEffect(() => {
    if (!response?.results?.length) return;
    const [result] = response.results;
    setCurrentResult(result);
  }, [response]);

  const updateHandle = (handle: string) => {
    refine("handle", handle);
  };

  return { currentResult, updateHandle };
}
